import {BUSINESS_NAME} from "@/content";

export type ParallaxContent = {
    title: string;
    subTitle: string;
    overline: string;
    imageUrl: string;
    buttonCTA: string;
    tint: string;
    align: 'left' | 'right' | 'center';
    buttonLink: string;
};

export const parallaxContent1: Omit<ParallaxContent, 'buttonLink'> & { buttonLink?: string } = {
    title:'Expert Concrete & Formwork Solutions',
    subTitle:'From precision formwork to reinforced concrete structures, our Sydney team delivers durable, high-quality formwork solutions.',
    overline: BUSINESS_NAME,
    imageUrl:'/images/parallax/pllx-1.jpg',
    buttonCTA:'Get a Free Quote Today',
    align:'left',
    tint:'rgba(0, 0, 0, 0.3)',
    buttonLink:undefined, //define this in the page
}

export const parallaxContent2: Omit<ParallaxContent, 'buttonLink'> & { buttonLink?: string } = {
    title:'Reliable Excavation & Structural Services',
    subTitle:'From bulk excavation to retaining walls and basement construction, we provide safe, efficient, and cost-effective solutions for Sydney builders and developers.',
    overline: BUSINESS_NAME,
    imageUrl:'/images/parallax/pllx-2.jpg',
    buttonCTA:'Start Your Project With Us',
    tint:'rgba(0, 0, 0, 0.3)',
    align:'right',
    buttonLink:undefined, //define this in the page
}
